import request from "@/plugins/axios";
import axios, { AxiosRequestConfig } from "axios";
const isDev =
  process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test";
const url = !isDev ? "" : "/api";
export const getCdnFileRes = async (fileUrl: string) => {
  const serve = axios.create({
    withCredentials: false,
    timeout: 1000 * 60 * 10,
  });
  const response = await serve.get(fileUrl);
  return typeof response.data === "object"
    ? JSON.stringify(response.data)
    : response.data;
};

// 最新版本号
export function getVersionInfo(versionNo: string) {
  const config: AxiosRequestConfig = {
    url: `${url}/common/version`,
    method: "post",
    data: {
      versionNo,
    },
  };
  return request(config);
}

// 获取广告位数据
export interface AdvertItem {
  imageUrl: string;
  hrefLink: string;
}

export function getAdverts() {
  const config: AxiosRequestConfig = {
    url: `${url}/advert/list`,
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    data: {},
  };
  return request<AdvertItem[]>(config);
}
